import React from 'react';

import moment from 'moment';

import Awards from './award_funcs';

import modal from 'Demora/modals/modal';

import AwardExplanation from '../acctHome/Leagues/AwardExplanation';

export default function (obj) {
	let u = window.reduxStore.getState().users;

	if (!u[obj]) {
		return null;
	}

	u = u[obj];

	let n;

	let c;

	if (
		u.previous_award &&
		(!u.current_award || u.previous_award > u.current_award)
	) {
		n = Awards.getName(u.previous_award);

		n =
			'Previously a ' +
			n +
			' member. (' +
			moment
				.utc(u.previous_award_time)
				.subtract(1, 'days')
				.format('MMMM YYYY') +
			')';

		c = Awards.getColourOfAward(u.previous_award);
	}

	if (!n && u.current_award >= u.previous_award) {
		n = Awards.getName(u.current_award);

		n = 'Currently a ' + n + ' member';

		c = Awards.getColourOfAward(u.current_award);
	}

	if (!n && !u.about) {
		return null;
	}

	return (
		<span>
			{!!n && (
				<div>
					<b style={{ color: c }}>{n}</b> &nbsp;
					<i className='far fa-question-circle' onClick={openModal} />
				</div>
			)}
			{u.about}
		</span>
	);
}

function openModal() {
	modal({
		id: 'show_awards',
		header: 'Awards',
		body: <AwardExplanation />,
	});
}
